import { MutateWidgetPayload, WidgetDto } from '@thingslog/repositories';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { WidgetTimeframeForm } from '../../forms';
import { DashboardSidebarWidgetCard } from './DashboardSidebarWidgetCard';

interface Props {
  widgetId: string;
  dashboardWidget: WidgetDto | null;
  isPersisting: boolean;
  onPersistWidget: (
    widgetId: string,
    payload: MutateWidgetPayload,
    callbacks?: { onSuccess?: () => void }
  ) => void;
  onClose: (widgetId: string) => void;
  onStartTour: () => void;
}

export const DashboardSidebarDashboardWidgetTimeframeWidget: FC<Props> = ({
  widgetId,
  dashboardWidget,
  isPersisting,
  onPersistWidget,
  onClose,
  onStartTour,
}: Props) => {
  const { t } = useTranslation();

  if (!dashboardWidget) {
    return (
      <DashboardSidebarWidgetCard
        title={t('dashboard_edit_widget_period', 'Edit Widget Period')}
        widgetId={widgetId}
        onClose={onClose}
        onStartTour={onStartTour}
      >
        <div className="p-4 text-sm text-gray-600">
          {t('dashboard_widget_no_longer_exists', 'Widget no longer exists.')}
        </div>
      </DashboardSidebarWidgetCard>
    );
  }

  return (
    <DashboardSidebarWidgetCard
      title={t('dashboard_edit_named_widget_period', 'Edit {{name}} Period', {
        name: dashboardWidget.settings.title || t('dashboard_widget', 'Widget'),
      })}
      widgetId={widgetId}
      expandable
      onClose={onClose}
      onStartTour={onStartTour}
    >
      <WidgetTimeframeForm
        dashboardWidget={dashboardWidget}
        disabled={isPersisting}
        onSubmit={(payload: MutateWidgetPayload): void => {
          onPersistWidget(dashboardWidget.id, payload, { onSuccess: () => onClose(widgetId) });
        }}
        onCancel={(): void => {
          onClose(widgetId);
        }}
      />
    </DashboardSidebarWidgetCard>
  );
};
